import React, { createContext, useState, useEffect, useMemo } from "react";

//API
import { getExamStats } from "../api/content";

export const ContentContext = createContext();

export const ContentProvider = (props) => {
  const [examStats, setExamStats] = useState([]);

  useEffect(() => {
    // Get exam statistics on mount
    const stats = getExamStats();
    setExamStats(stats);
  }, []);

  // Helper function to get content counts for a specific certification
  const getContentCounts = (certKey) => {
    const cert = examStats.find(stat => stat.key === certKey);
    return cert || { questions: 0, flashcards: 0, articles: 0 };
  };

  // Calculate totals across all certifications
  const totals = useMemo(() => {
    return examStats.reduce(
      (acc, stat) => ({
        questions: acc.questions + stat.questions,
        flashcards: acc.flashcards + stat.flashcards,
        articles: acc.articles + stat.articles,
        practiceTests: acc.practiceTests + stat.practiceTests,
        glossary: acc.glossary + stat.glossary,
      }),
      { questions: 0, flashcards: 0, articles: 0, practiceTests: 0, glossary: 0 }
    );
  }, [examStats]);

  return (
    <ContentContext.Provider
      value={{
        examStats,
        getContentCounts,
        totals,
      }}
    >
      {props.children}
    </ContentContext.Provider>
  );
};

